import * as React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { makeStyles, Title3, Button, tokens, Subtitle2 } from "@fluentui/react-components";
import { ChevronLeftRegular } from "@fluentui/react-icons";

export interface ModuleLayoutProps {
  title: string;
}

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    maxHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px",
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
});

const ModuleLayout: React.FC<ModuleLayoutProps> = ({ title }) => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <Button
          appearance="subtle"
          icon={<ChevronLeftRegular />}
          onClick={() => navigate("/")}
          aria-label="Back to Home"
        />
        <Subtitle2>{title}</Subtitle2>
      </header>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default ModuleLayout;
